import React , {useState} from 'react';
import {Autocomplete} from '@react-google-maps/api';
import {AppBar , Toolbar ,Typography,InputBase, Box } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import logo from '../../assets/logo.svg';
import useStyles from './styles';


function Header({setCoordinates}) {
    const classes = useStyles();
    const [autocomplete, setAutocomplete] = useState(null)

    const onLoad = (autoC) => setAutocomplete(autoC);
    const onPlaceChanged = ()=>{
        const lat = autocomplete.getPlace().geometry.location.lat();
        const lng = autocomplete.getPlace().geometry.location.lng();

         // update coordinate state on app
        setCoordinates({lat,lng})
    }
    return (
        <AppBar position='static' >
            <Toolbar className= {classes.toolbar}>

                <Typography variant='h5' className = {classes.title}>
                    <img src={logo} alt="logo" width="200px" />
                </Typography>
                <Box display="flex">
                    <Typography variant='h6' className = {classes.title}>
                        Explore new joints 
                    </Typography>
                    <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                        <div className={classes.search}>
                            
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <InputBase placeholder="Search..." classes={{root: classes.inputRoot, input: classes.inputInput}}/>

                        </div>
                    </Autocomplete> 
                </Box>

            </Toolbar>
        </AppBar>
    )
}

export default Header
